import React from 'react';
import 'antd/dist/antd.css';
import { Form, Row, Col, Input, Select, Icon, Button } from 'antd';
import { debounce } from "lodash";

class CostListingSearchForm extends React.Component {
  state = {
    sortBy: [
      {name: 'Default', value: ''},
    ]
  };

  async componentDidMount() {
    await this.setFieldsValue();
  }

  setFieldsValue = () => {
    this.props.form.setFieldsValue({
      search: '',
      sortBy: ''
    });
  }

  handleChangeSearch = (event) => {
    event.persist();
    if (!this.debouncedFn) {
      this.debouncedFn = debounce(() => {
        this.props.form.setFieldsValue({
          search: event.target.value
        });
        this.handleOnkeySearch()
      }, 600);
    }

    this.debouncedFn();
  }

  handleOnkeySearch = () => {
    this.props.form.validateFields((err, values) => {
      this.props.onSearch(values);
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form layout="inline">
        <Row gutter={24}>
          <Col xs={{span: 24}} md={{span: 12}}>
            <Form.Item>
              {getFieldDecorator('search')(
                <Input
                  type='text'
                  onChange={this.handleChangeSearch}
                  prefix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)' }}/>}
                  placeholder="Search Vendor"
                />,
              )}
            </Form.Item>
          </Col>
          <Col xs={{span: 24}} md={{span: 12}}>
            <Row gutter={24} type='flex' justify="end">
              <Col>
              <Form.Item label="Sort By">
                {getFieldDecorator('sortBy',{})(
                  <Select
                  placeholder="Sort By"
                  style={{ width: '130px' }}
                >
                <Select.Option key={1} value={""}>
                  Default
                </Select.Option>
                </Select>
                )}
              </Form.Item>
              </Col>
              <Col>
                <Button style={{marginTop: 4}} type="primary" onClick={this.props.onAddVendor}>
                  <Icon type="plus" />
                  Add Cost
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    );
  }
}

const CostListingSearch = Form.create({ name: 'cost_listing_search' })(CostListingSearchForm);
export default CostListingSearch;
          


// WEBPACK FOOTER //
// ./src/containers/PriceManagement/CostListingSearch.js